import { resolveEntityValue } from '../lib/financial-advisors/resolve-entity-value';
import type { DriverMappingConfig } from '../lib/financial-advisors/types';

export interface TableDriversProps {
  marketplaceEntity: Record<string, unknown>;
  drivers: DriverMappingConfig[];
}

export function TableDrivers({ marketplaceEntity, drivers }: TableDriversProps) {
  return drivers.map((driver, index) => {
    const value = resolveEntityValue(marketplaceEntity, driver.marketplaceEntityKey) ?? '-';
    const description = resolveEntityValue(
      marketplaceEntity,
      driver.marketplaceEntityDescriptionKey,
    );

    return (
      <td
        key={`${driver.label}-${index}`}
        className="w-[190px] min-w-[130px] px-7 pt-7 pb-4 align-top lg:border-b lg:border-border"
      >
        <div className="flex flex-col items-start gap-4">
          <p className="m-0 text-base">{value}</p>
          {description ? (
            <span className="typography-text-small text-foreground">{description}</span>
          ) : null}
        </div>
      </td>
    );
  });
}
